export default __webpack_public_path__ + "static/media/Build_websites_with_github_-_adamr.space___Codecademy.c1351c36.pdf";